import { render } from "./licenseDeactivate.vue?vue&type=template&id=48f73f1e&scoped=true"
import script from "./licenseDeactivate.vue?vue&type=script&lang=js"
export * from "./licenseDeactivate.vue?vue&type=script&lang=js"

import "./licenseDeactivate.vue?vue&type=style&index=0&id=48f73f1e&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f73f1e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
